var Request = require('../../../helper/request');

function Event(app, companyId){
	var self = this;
	self.request = new Request(app);
	self.companyId = companyId;

	self.routes = {
		index: {
			url: "/company/"+self.companyId+"/search/feed/event?month=:month&year=:year",
			method: "GET"
		}
	};
}

Event.prototype.index = function(month, year, branchId = false){
	var self = this;
	if(branchId){
		var uri = self.routes.index.url.replace(':month', month).replace(':year', year);
	} else {
		var uri = self.routes.index.url.replace(':month', month).replace(':year', year) + "&branch_id="+parseInt(branchId);
	}
	return self.request.get(uri);
};

module.exports = Event;